export class ListFindingExclusionPatternsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ExclusionPatternFilterConditions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListFindingExclusionPatternsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
